import { merge } from 'lodash-es';

import { MovableUITheme } from '@movable/ui';
import { ThemeOptions, createTheme } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';

import localTheme from './local-theme';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

const mergedTheme = merge({}, MovableUITheme, localTheme);

const theme = createTheme(mergedTheme as ThemeOptions);

export default theme;
